export default __webpack_public_path__ + "static/media/Facebook.f9d8359a.svg";